window.autosizeTextarea = function autosizeTextarea() {
  if (document.querySelector('textarea[data-autosize]')) {
    const autosizeTextareaElements = document.querySelectorAll(
      'textarea[data-autosize]'
    );
    autosizeTextareaElements.forEach((textarea) => {
      const startHeight = textarea.offsetHeight;
      textarea.addEventListener('input', autosize);
      function autosize() {
        const el = this;
        const newHeight = el.scrollHeight;
        if (newHeight > startHeight) {
          el.style.minHeight = `${el.scrollHeight}px`;
        } else {
          el.style.minHeight = startHeight;
        }
      }
    });
  }
};
autosizeTextarea();

// meta counter

const counters = document.querySelectorAll('.meta-counter');

if (counters.length) {
  counters.forEach((counter) => {
    let count = 1;
    const counterMinus = counter.querySelector('.counter-minus');
    const counterPlus = counter.querySelector('.counter-plus');
    const counterValue = counter.querySelector('.counter-value');

    counterValue.addEventListener('input', () => {
      const newValue = parseInt(counterValue.value);
      if (!isNaN(newValue) && newValue > 0 && newValue <= 999) {
        count = newValue;
      }
    });

    counterMinus.addEventListener('click', () => {
      if (count - 1 <= 0) return;
      count -= 1;
      counterValue.value = count;
    });

    counterPlus.addEventListener('click', () => {
      if (count >= 999) return;

      if (count + 1 > 9999) return;
      count += 1;
      counterValue.value = count;
    });
  });
}

function resizeInput(input) {
  const mirror = document.getElementById('text-mirror');

  mirror.textContent = input.value || input.placeholder;

  input.style.width = `${mirror.offsetWidth + 20}px`;
}
document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('.counter-value');

  inputs.forEach((input) => {
    resizeInput(input);
    input.addEventListener('input', () => resizeInput(input));
  });
});

function formatInput(inputEl) {
  const sanitizedValue = inputEl.value.replace(/[^\d.,]/g, '');

  inputEl.value = '₹' + sanitizedValue;
}

if (document.querySelector('.salary-input')) {
  const salaryInputsArr = document.querySelectorAll('.salary-input');
  salaryInputsArr.forEach((input) => {
    input.addEventListener('input', () => {
      formatInput(input);
    });
  });
}

window.clearSalaryInput = function clearSalaryInput(id) {
  const salaryInputEl = document.querySelector(`#${id}`);
  salaryInputEl.value = '';
  formatInput(salaryInputEl, 999999);
};

window.passwordInputs = function passwordInputs() {
  if (document.querySelector('.password-input')) {
    const passwordInputsArr = document.querySelectorAll('.password-input');
    passwordInputsArr.forEach((password) => {
      const btn = password.querySelector('.password-input__btn');
      const input = password.querySelector('input');

      btn.addEventListener('click', () => {
        inputIconFunc();
      });

      function inputIconFunc() {
        if (!btn.classList.contains('is-password-hidden')) {
          btn.classList.add('is-password-hidden');
          input.type = 'password';
        } else {
          btn.classList.remove('is-password-hidden');
          input.type = 'text';
        }
      }
      inputIconFunc();
    });
  }
};
passwordInputs();
